/**
 * @author Yakov.Gushchin
 * @version 1.0.0
 */
import * as icons from './icons';

export {
    icons,
};
